export default function printReportClient(idCliente, type, startDate, endDate) {
  const token = localStorage.getItem("token");
  printReportPerClient(token, idCliente, type, startDate, endDate);
}

function printReportPerClient(token, idCliente, type, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales/gerar/relatorio/geral/todas/vendas/por/periodo/and/client/group/A4/unique?auth=${token}&idCliente=${idCliente}&type=${type}&startDate=${startDate}&endDate=${endDate}`
  );
}